export const defaultColors = [
    "#E73F14", // naranja intenso (base)
    "#F4511E", // naranja quemado fuerte
    "#FF5722", // naranja vivo (material orange)
    "#FF7043", // naranja coral
    "#FF8A65", // naranja medio claro
    "#FFAB91", // naranja pastel suave
    "#FFCCBC", // piel salmón claro
    "#FFE0B2", // durazno claro
    "#FFE9C7", // beige cálido
    "#FFF3E0", // marfil cálido
    "#FCE8DD", // rosado claro neutro
    "#F5E1D8", // rosa empolvado
    "#EAD3C4", // nude claro
    "#DFC5B0", // almendra clara
    "#D5B49C", // arena tostada
    "#CAB38C", // beige grisáceo
    "#C0A77F", // marrón claro cálido
    "#B4996F", // tostado tenue
    "#A88460", // caramelo suave
    "#967657"  // marrón suave apagado
]
